import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { FundProjectionScreenOutlined, FundViewOutlined, TableOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/report',
    name: 'report',
    redirect: '/report/view',
    component: Layout,
    meta: {
      title: 'Report',
      icon: renderIcon(FundProjectionScreenOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: [
        'financial_report_read',
        'financial_report_taxes_included_read',
        'capital_budget_report_read',
        'gl_reconciliation_read',
      ],
      sort: 7,
    },
    children: [
      {
        path: 'view',
        name: 'report_view',
        meta: {
          title: 'View',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['report_view_read'],
          hidden: true,
        },
        component: () => import('@/views/report/view/index.vue'),
      },
      {
        path: 'financial_report',
        name: 'financial_report',
        meta: {
          title: 'Financial (no taxes)',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['financial_report_read'],
          spname: 'financialReportTaxesSeparate',
        },
        component: () => import('@/views/report/view/financialReport.vue'),
      },
      // {
      //   path: 'financial_report_with_gl',
      //   name: 'financial_report_with_gl',
      //   meta: {
      //     title: 'Financial with GL (no taxes)',
      //     icon: renderIcon(FundViewOutlined),
      //     hidden: true,
      //     //配置该路由需要哪些权限可访问 这里是针对单个路由
      //     permissions: ['financial_report_read'],
      //     spname: 'financialReportTaxesSeparateWithGL',
      //   },
      //   component: () => import('@/views/report/view/financialReportWithGL.vue'),
      // },
      {
        path: 'financial_report_taxes_included',
        name: 'financial_report_taxes_included',
        meta: {
          title: 'Financial (taxes)',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['financial_report_taxes_included_read'],
          spname: 'financialReportTaxesIncluded',
        },
        component: () => import('@/views/report/view/financialReportWithTax.vue'),
      },
      {
        path: 'cash_allowance_summary',
        name: 'cash_allowance_summary',
        meta: {
          title: 'CA Summary',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['cash_allowance_summary_read'],
          spname: 'cash_allowance_summary',
        },
        component: () => import('@/views/report/view/cashAllowanceSummary.vue'),
      },
      {
        path: 'cash_allowance_commitment',
        name: 'cash_allowance_commitment',
        meta: {
          title: 'CA CCL',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['cash_allowance_commitment_read'],
          spname: 'cash_allowance_commitment',
        },
        component: () => import('@/views/report/view/cashAllowanceCommitment.vue'),
      },
      {
        path: 'gl_reconciliation',
        name: 'gl_reconciliation',
        meta: {
          title: 'GL Reconciliation',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['gl_reconciliation_read'],
          spname: 'gl_commitment_match',
        },
        component: () => import('@/views/report/view/gl/glReconciliation.vue'),
      },
      /*
      {
        
        path: 'capital_budget_report',
        name: 'capital_budget_report',
        
        meta: {
          title: 'Capital Budget',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['capital_budget_report_read'],
          
          spname:'capitalBudgetReport',
         
        },
        component: () => import('@/views/report/view/capitalBudgetReport.vue'),
      },
      {
        path: 'pivot-table',
        name: 'report_pivot_table',
        meta: {
          title: 'Pivot Table',
          icon: renderIcon(TableOutlined),
          hidden:true,
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['report_pivot_table_read'],
        },
        component: () => import('@/views/report/pivot-table/index.vue'),
      },
      */
    ],
  },
];

export default routes;
